<template>
    <template v-if="!isDataLoading">
        <div class="quiz__info">
            <h1 class="quiz__title">{{ quiz.title }}</h1>
            <p class="quiz__desc">{{ quiz.description }}</p>
            <img v-if="quiz.image" :src="`${apiUri}${quiz.image.fullpath}`" :alt="quiz.title" class="quiz__img" />
            <img v-else src="@/assets/images/start-quiz.svg" :alt="quiz.title" class="quiz__img" />
            <div class="btn-wrapper">
                <router-link :to="{name: 'quiz'}" class="btn btn--primary">{{ $t('button.start-quiz') }}</router-link>
            </div>
        </div>
        
        <div class="quiz__img-wrapper">
            <img v-if="quiz.image" :src="`${apiUri}${quiz.image.fullpath}`" :alt="quiz.title" class="quiz__img" />
            <img v-else src="@/assets/images/start-quiz.svg" :alt="quiz.title" class="quiz__img" />
        </div>
    </template>
</template>

<script>
export default {
    name: 'QuizStart',
    props: ['quiz', 'isDataLoading'],
    computed: {
        apiUri() {
            return process.env.VUE_APP_APOLLO_API_URI;
        }
    }
}
</script>
